module.exports = __webpack_public_path__ + "img/zs10.5fe98e2d.png";